import React, { useEffect, useState } from "react";
import { fetchData } from "../../Components/common/utils";
import Select from 'react-select';
import Ebikes from "./ebikes";
import Electronics from "./electronics";
import Solar from "./solar";
import Evehicle from "./evehicle";
const ComparePRoduct = () => {
    const [categoryList, setCategoryList] = useState([]);
    const [selectedCategory, setselectedCategory] = useState('')
    const [selectedCategoryName, setselectedCategoryName] = useState('')
    const [selectedProductOne, setSelectedProductOne] = useState({})
    const [selectedProductTwo, setSelectedProductTwo] = useState({})
    const [productList, setProductList] = useState([])
    const [productOptions, setProductOptions] = useState([])
    const [productOne, setProductOne] = useState(null)
    const [productTwo, setProductTwo] = useState(null)
    const [isLoading, setisLoading] = useState(false)
    useEffect(() => {
        fetchCategory();
    }, []);
    const fetchCategory = async () => {
        const url = "api/category/all/list";
        const result = await fetchData(url);
        if (result) {
            setCategoryList(result.data);
        }
    };
    const fetchProducts = async (id, cat) => {
        setisLoading(true)
        const url = "api/details/" + id;
        const result = await fetchData(url);
        debugger
        if (result) {
            let flatArray = [];

            if (cat.toLowerCase() === 'e-bikes') {
                const newarray = result.data.filter(item =>
                    !(item.specification === undefined && item.variants.length === 0)
                );

                const cleanedData = newarray.map(product => {
                    const filteredVariants = product.variants.filter(
                        variant => variant.bike_specification !== null
                    );

                    return {
                        ...product,
                        variants: filteredVariants
                    };
                });
                cleanedData.forEach(product => {
                    // Filter only valid variants (with bike_specification)
                    const validVariants = product.variants.filter(
                        variant => variant.bike_specification !== null
                    );

                    if (validVariants.length > 0) {
                        // Push all valid variants and skip the product
                        validVariants.forEach(variant => {
                            flatArray.push({
                                ...variant,
                                source: 'variant',
                                logo: product?.logo
                            });
                        });
                    } else if (product.specification !== null) {
                        // No valid variants — include the product itself with renamed key
                        const { specification, ...rest } = product; // remove 'specification'
                        flatArray.push({
                            ...rest,
                            source: 'product',
                            bike_specification: specification, // renamed field
                        });
                    }
                });
            } else if (cat.toLowerCase() === 'electronics') {
                flatArray = result.data.filter(item =>
                    !(item.electronicspecification === null)
                );
            } else if (cat.toLowerCase() === 'solar') {
                flatArray = result.data.filter(item =>
                    !(item.accessorie === null && item.solarinverter === null && item.solarpanel === null)
                );

            } else if (cat.toLowerCase() === 'e-vehicles') {
                const newarray = result.data.filter(item =>
                    !(item.variants.length === 0)
                );

                const cleanedData = newarray.map(product => {
                    const filteredVariants = product.variants.filter(
                        variant => !(variant.additionalfeature === null && variant.diminsionweight === null && variant.engineperformance === null
                            && variant.exterior === null && variant.fuelcharging === null && variant.interiorcomfort === null && variant.safetyfeature === null && variant.technologyconnectivity === null
                        )
                    );

                    return {
                        ...product,
                        variants: filteredVariants
                    };
                });
                cleanedData.forEach(product => {
                    // Filter only valid variants (with bike_specification)
                    // const validVariants = product.variants.filter(
                    //     variant => variant.bike_specification !== null
                    // );

                    if (product.variants.length > 0) {
                        // Push all valid variants and skip the product
                        product.variants.forEach(variant => {
                            flatArray.push({
                                ...variant,
                                source: 'variant',
                                logo: product?.logo
                            });
                        });
                    }
                });

            }
            const newList = flatArray.map(item => ({
                value: item.title,
                label: item?.logo?.title + '-' + item.title,
                id: item.id
            }));
            setProductOptions(newList)
            setProductList(flatArray);
            setisLoading(false)
        } else {
            setSelectedProductOne({});
            setSelectedProductTwo({});
            setProductOne(null)
            setProductTwo(null)
             setisLoading(false)
        }
    };
    const handlechange = (e) => {
        setselectedCategory(e.target.value)
        if (e.target.value !== '') {
            const cat = categoryList.find(item => item.id === e.target.value)
            setselectedCategoryName(cat.title)
            setSelectedProductOne({});
            setSelectedProductTwo({});
            setProductOne(null)
            setProductTwo(null)
            fetchProducts(e.target.value, cat.title);
        }
    }
    const handleProductChangeOne = (value) => {
        setProductOne(value)
        const pone = productList.find(item => item.id === value.id);
        setSelectedProductOne(pone)
    }
    const handleProductChangeTwo = (value) => {
        setProductTwo(value)
        const pone = productList.find(item => item.id === value.id);
        setSelectedProductTwo(pone)
    }

    return (
        <div className="" style={{ backgroundColor: '#8080802e' }}>
            <div className="container p-3">
                <div className="mt-4">
                    {/* Modern Header */}
                    <div className="brand-banner py-5 px-3 text-center text-white mb-4">
                        <h1 className="display-4 fw-bold mb-2">Explore. Compare. <span className="brand-name">Choose wisely.</span></h1>
                        <p className="lead">Because your money deserves better decisions.</p>
                    </div>
                </div>
                <div className="bg-white rounded p-3">
                    <label>Select Category</label>
                    <select value={selectedCategory} onChange={handlechange} className="form-select h-100" aria-label="Default select example">
                        <option value='' selected>Select Category</option>
                        {categoryList.map((item, index) => (
                            <option key={index} value={item.id}>{item.title}</option>
                        ))}
                    </select>
                    <hr />
                    <div className="row my-4">
                        <div className="col-md-6 col-12 mb-3">
                            <Select
                                value={productOne}
                                onChange={handleProductChangeOne}
                                placeholder='Select Product'
                                options={productOptions}
                                isLoading={isLoading}
                            />
                        </div>
                        <div className="col-md-6 col-12">
                            <Select
                                value={productTwo}
                                onChange={handleProductChangeTwo}
                                placeholder='Select Product'
                                options={productOptions}
                                isLoading={isLoading}
                            />
                        </div>
                    </div>
                    <hr />
                    <div className="row my-4">
                        {Object.keys(selectedProductOne).length > 0 && (
                            <div className="col-md-6 col-12 text-center">
                                <img src={selectedProductOne?.media[0]?.original_url} alt="image1" className="compare-img" />
                                <h4 className="mt-2 fw-bold text-success">{selectedProductOne?.title}</h4>
                                <h5>{selectedProductOne?.source === 'product' ? selectedProductOne?.price_start : selectedProductOne?.price_range}</h5>
                            </div>
                        )}
                        {Object.keys(selectedProductTwo).length > 0 && (
                            <div className="col-md-6 col-12 text-center">
                                <img src={selectedProductTwo?.media[0]?.original_url} className="compare-img" alt="image2" />
                                <h4 className="mt-2 fw-bold text-success">{selectedProductTwo?.title}</h4>
                                <h5>{selectedProductTwo?.source === 'product' ? selectedProductTwo?.price_start : selectedProductTwo?.price_range}</h5>

                            </div>
                        )}
                    </div>
                </div>
                <div className="mt-4">
                    {(selectedCategoryName?.toLowerCase() === 'e-bikes') &&
                        (Object.keys(selectedProductOne).length > 0 || Object.keys(selectedProductTwo).length > 0) && (
                            <Ebikes bikeone={selectedProductOne} biketwo={selectedProductTwo} />
                        )}

                    {(selectedCategoryName?.toLowerCase() === 'electronics') &&
                        (Object.keys(selectedProductOne).length > 0 || Object.keys(selectedProductTwo).length > 0) && (
                            <Electronics bikeone={selectedProductOne} biketwo={selectedProductTwo} />
                        )}
                    {(selectedCategoryName?.toLowerCase() === 'solar') &&
                        (Object.keys(selectedProductOne).length > 0 || Object.keys(selectedProductTwo).length > 0) && (
                            <Solar productone={selectedProductOne} producttwo={selectedProductTwo} />
                        )}
                    {(selectedCategoryName?.toLowerCase() === 'e-vehicles') &&
                        (Object.keys(selectedProductOne).length > 0 || Object.keys(selectedProductTwo).length > 0) && (
                            <Evehicle productone={selectedProductOne} producttwo={selectedProductTwo} />
                        )}
                </div>

            </div>
        </div>
    );
};

export default ComparePRoduct;